// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.upload-file-container[data-v-a77a702a] {\n  display: flex;\n  padding: 9px;\n  border: 1px dashed #e4e6ef;\n  cursor: pointer;\n  border-radius: 5px;\n}\n.upload-file-container.drag-active[data-v-a77a702a] {\n  border: 1px dashed #08a94c;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
